<template>
  <div id="app">
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header">
      <nav-top></nav-top>
      <nav-left></nav-left>
      <main class="mdl-layout__content">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import NavTop from './components/shared/NavTop'
import NavLeft from './components/shared/NavLeft'

export default {
  name: 'App',
  components: {
    NavTop,
    NavLeft
  }
}
</script>

<style lang="scss" scoped>
#app {
  html, body {
    font-family: 'Roboto', 'Helvetica', sans-serif;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue